export const role = [
  {
    label: "Super Admin",
    value: "SA",
  },
  {
    label: "Admin Biasa",
    value: "AB",
  },
  {
    label: "Pemasaran",
    value: "PM",
  },
  {
    label: "Kesekretariatan",
    value: "KS",
  },
];
